export default function GraphIcon() {
	return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon graph">
		<path fillRule="evenodd" clipRule="evenodd" d="M5.99033 15.9742H9.98388V0H5.99033V15.9742ZM0 15.9742H3.99355V7.9871H0V15.9742ZM11.9807 4.99194V15.9742H15.9742V4.99194H11.9807Z" fill="#008000"/>
		<mask id="mask0_212_32743" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
			<path fillRule="evenodd" clipRule="evenodd" d="M5.99033 15.9742H9.98388V0H5.99033V15.9742ZM0 15.9742H3.99355V7.9871H0V15.9742ZM11.9807 4.99194V15.9742H15.9742V4.99194H11.9807Z" fill="white"/>
		</mask>
		<g mask="url(#mask0_212_32743)">
		</g>
	</svg>;
}
